import testTemplateCommitTypes from "./commit-types";


const INITIAL_TEST_TEMPLATES_STATE = {
  list: [],
  map: {}
};

function testTemplateReducers(state = INITIAL_TEST_TEMPLATES_STATE, action) {
  if (!action || !action.type) {
    return state;
  }

  switch (action.type) {
    case testTemplateCommitTypes.SET_TEST_TEMPLATES:
      return {
        ...state,
        list: action.list,
        map: action.list.reduce((acc, tt) => ({...acc, [tt.id]: tt}), {})
      };
    case testTemplateCommitTypes.PUSH_TEST_TEMPLATE:
      return {
        ...state,
        list: [...state.list, action.tt],
        map: {
          ...state.list,
          [action.tt.id]: action.tt
        }
      };
    case testTemplateCommitTypes.UPDATE_TEST_TEMPLATE:
      return {
        ...state,
        list: state.list.map(tt => tt.id === action.tt.id ? action.tt : tt),
        map: {
          ...state.list,
          [action.tt.id]: action.tt
        }
      };
    case testTemplateCommitTypes.SET_TEST_TEMPLATE_REPORTS:
      const testReportsReduced = action.testReports.reduce(function (acc, test) { 
        let answers = {};
        if (test.correct) {
          answers.correctAnswers = test.count;
        }
        else {
          answers.wrongAnswers = test.count;
        }
        
        const key = test['question_id'];
        acc[key] = {
          ...acc[key],
          ...answers
        };

        return acc;
      }, {});
      
      let testTemplateQuestions = [];
      const currentTestTemplate = state.list.find(test => test.id == action.testTemplateId);
      if (currentTestTemplate && currentTestTemplate.questions) {
        testTemplateQuestions = currentTestTemplate.questions
          .reduce(function (acc, question) {
            const key = question['id'];

            let correctAnswers = 0;
            let wrongAnswers = 0;
            if (testReportsReduced[key]) {
              correctAnswers = testReportsReduced[key].correctAnswers;
              wrongAnswers = testReportsReduced[key].wrongAnswers;
            }

            acc.push({
              ...question,
              correctAnswers,
              wrongAnswers
            });

            return acc;
          }, []);
      }

      return {
        ...state,
        testQuestionReports: testTemplateQuestions,
      };
    default:
      return state;
  }
}

export default testTemplateReducers
